module.exports = __webpack_public_path__ + "static/img/goodness3.3a603f4b.png";